import React from 'react';

export default function UndergraduateApplicationGuidance({ defaultExpanded = false }: { defaultExpanded?: boolean }) {
  return <details className="application-guidance mb-4" open={defaultExpanded}>
    <summary><span className="application-guidance-title">Before you apply</span><span>Review your degree audit and final-term courses. Read the readiness checklist and evaluation timeline.</span></summary>
    <div className="application-guidance-content">
    <p>Please review and complete the graduation application in full to request an official evaluation of your degree audit and determine graduation eligibility.</p>

    <h2 className="h4">Graduation Application Readiness Checklist</h2>
    <p>Before continuing, ask yourself the following questions:</p>
    <ul>
      <li>Have you registered for courses in your final term?</li>
      <li>Have you reviewed your degree audit (DARs)?</li>
      <li>Does your degree audit show all requirements are met or in progress?</li>
      <li>Have you met with your faculty and/or professional advisor to resolve any missing requirements?</li>
    </ul>
    <p>If you answered no to any of the above, please visit <a href="https://www.mnsu.edu/student-support/registration-and-records/prepare-to-graduate-undergraduate-process/">Graduation Process: Undergraduate Students</a></p>

    <h2 className="h4">Evaluation Timeline</h2>
    <ul>
      <li>After submitting your application, check your MavMAIL regularly for the status of your degree audit evaluation.</li>
      <li>Normal processing time: 7 – 10 business days</li>
      <li>Peak periods: 4 – 6 weeks due to the following:
        <ol>
          <li>End-of-term degree conferral</li>
          <li>Multiple graduation application windows open</li>
        </ol>
      </li>
      <li>Applications are prioritized by current term and processed on a rolling basis in the order received.</li>
    </ul>

    <h2 className="h4">Substitutions and/or Waivers (if applicable)</h2>
    <ul>
      <li>May take 3 – 5 business days to process.</li>
      <li>Plan ahead to avoid delays in your degree audit evaluation.</li>
    </ul>

    <h2 className="h4">Final Semester Transfer Courses (if applicable)</h2>
    <ul>
      <li>If you’re transferring in courses during your final semester:
        <ol>
          <li>List the course name(s) and the school they are transferring from in the ‘Notes for the Graduation Evaluation Team’ section below at the end of this form.</li>
        </ol>
      </li>
      <li>Transcript Requirements:
        <ol>
          <li>MinnState System course(s): No transcript needed - we have access.</li>
          <li>Course(s) outside the MinnState System: You must provide an Official Transcript to Minnesota State Mankato after final grade(s) has been posted.</li>
        </ol>
      </li>
    </ul>
    </div>
  </details>;
}
